var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-page"},[_c('navbarBox'),_c('adduser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }